<template>
  <div>
    <exhibition></exhibition>
  </div>
</template>

<script>
import exhibition from '@views/appletManagement/exhibition'
export default {
  data() {
    return {
      
    };
  },
  components:{
    exhibition
  },

  mounted() {
    
  },

  methods: {
    
  },
};
</script>

<style lang="scss" scoped>

</style>